import * as actionTypes from './actionTypes';
import { processConfirmService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { actionsFlashMessageError } from '@app/src/common/flashMessageError';
import { isClientEnv } from '@app/src/utils/validations';
import { fetchValidate } from '@app/src/common/session';

const isClient = isClientEnv();

export const fetchProcessConfirmRequest = () => ({
  type: actionTypes.FETCH_PROCESS_CONFIRM_REQUEST
});

export const fetchProcessConfirmFailure = () => ({
  type: actionTypes.FETCH_PROCESS_CONFIRM_FAILURE
});

export const fetchProcessConfirmSuccess = (data: any) => ({
  type: actionTypes.FETCH_PROCESS_CONFIRM_SUCCESS,
  data
});

export const clearProcessConfirmData = () => ({
  type: actionTypes.CLEAR_PROCESS_CONFIRM_DATA
});

export const fetchProcessConfirmConsume = (json) => {
  return async dispatch => {
    dispatch(fetchProcessConfirmRequest());
    // await dispatch(fetchValidate());
    try {
      const data = await processConfirmService.postConsume(json);
      dispatch(fetchProcessConfirmSuccess(data));
    } catch (error) {
      console.log('Error action fetch ProcessConfirm', error);
      dispatch(actionsModalError.openModalError());
      dispatch(fetchProcessConfirmFailure());
    }
  }
};

const STATE_PAYMENT = {
  SUCESS: 'approved',
  PENDING: 'pending',
  DENIED: 'denied',
  FAILURED: 'failed'
};

export const fetchProcessConfirmPayment = (json) => {
  return async dispatch => {
    dispatch(fetchProcessConfirmRequest());
    await dispatch(fetchValidate());
    try {
      const data = await processConfirmService.putPayment(json);
      if (isClient) {
        (window as any).paymentProcess = true;
      }
      if (data.status === STATE_PAYMENT.FAILURED) {
        dispatch(actionsFlashMessageError.openFlashMessage());
        dispatch(fetchProcessConfirmSuccess(data));
      }
      if (data.status === STATE_PAYMENT.DENIED) {
        dispatch(actionsFlashMessageError.openFlashMessage());
        dispatch(fetchProcessConfirmSuccess(data));
      }
      if (data.status === STATE_PAYMENT.SUCESS || data.status === STATE_PAYMENT.PENDING) {
        dispatch(fetchProcessConfirmSuccess({
          ...data,
          date: data.paymentDate || data.expireDate
        }));
      }

    } catch (error) {
      console.log('Error action fetch ProcessConfirm', error);
      dispatch(actionsModalError.openModalError());
      dispatch(fetchProcessConfirmFailure());
    }
  }
};
